import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

// VFX: Pricing Tier Highlight
// Category: ui-elements · Tags: pricing, table, tier, highlight, saas
const tiers = [
  { name: "Starter", price: "9", features: ["10 projects", "1 user", "Email support"], highlight: false, color: "#94a3b8" },
  { name: "Pro", price: "29", features: ["Unlimited projects", "5 users", "Priority support", "Advanced analytics"], highlight: true, color: "#a855f7" },
  { name: "Team", price: "89", features: ["Everything in Pro", "20 users", "SSO + audit log"], highlight: false, color: "#94a3b8" },
];

export default function CardPricingTableTierHighlight1000Ms() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  return (
    <AbsoluteFill style={{
      background: "linear-gradient(180deg, #0a0e1a 0%, #1e293b 100%)",
      alignItems: "center", justifyContent: "center", flexDirection: "row", gap: 24, padding: 60
    }}>
      {tiers.map((t, i) => {
        const sp = spring({ frame: frame - i * 4, fps, config: { damping: 16, stiffness: 110 } });
        const highlightSp = t.highlight ? spring({ frame: frame - 20, fps, config: { damping: 14, stiffness: 90 } }) : 0;
        const glow = t.highlight ? interpolate(highlightSp, [0, 1], [0, 1]) : 0;
        const scale = t.highlight ? interpolate(highlightSp, [0, 1], [1, 1.08]) : 1;
        return (
          <div key={t.name} style={{
            width: 280,
            background: t.highlight ? "rgba(168,85,247,0.08)" : "rgba(255,255,255,0.03)",
            border: t.highlight ? `2px solid ${t.color}` : "1px solid rgba(255,255,255,0.08)",
            borderRadius: 24,
            padding: "40px 28px",
            opacity: sp,
            transform: `translateY(${(1 - sp) * 60}px) scale(${scale})`,
            boxShadow: t.highlight ? `0 0 ${60 * glow}px ${t.color}55, 0 24px 64px rgba(0,0,0,0.4)` : "0 16px 40px rgba(0,0,0,0.3)",
          }}>
            {t.highlight && (
              <div style={{
                fontSize: 12, fontWeight: 800, color: t.color,
                letterSpacing: "0.3em", textTransform: "uppercase", marginBottom: 8
              }}>Most Popular</div>
            )}
            <div style={{ fontSize: 28, fontWeight: 700, color: "#f8fafc", marginBottom: 12 }}>{t.name}</div>
            <div style={{ display: "flex", alignItems: "baseline", gap: 4, marginBottom: 28 }}>
              <span style={{ fontSize: 56, fontWeight: 900, color: "#f8fafc" }}>${t.price}</span>
              <span style={{ fontSize: 18, color: "#94a3b8" }}>/mo</span>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {t.features.map(f => (
                <div key={f} style={{ fontSize: 16, color: "#cbd5e1", display: "flex", alignItems: "center", gap: 10 }}>
                  <span style={{ color: t.color, fontWeight: 800 }}>✓</span> {f}
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
